import { defined, Cesium3DTileStyle, Ray, Cartesian3, } from "cesium";
import { HeightMap, DEFAULT_HEIGHT_MAP_BOX_SIZE } from "../../core/height-map";
import { AssetType } from "../../types";
import { createPointCloudGeom } from "./utils";
import { EarthBrainUtils } from "../../utilities/earthbrainutility";
export class DesignTileSet {
    assetType = AssetType.Design_Data;
    _id;
    _cesiumEntity;
    _heightMap;
    _styleOptions;
    _geometry;
    _viewer;
    get id() {
        return this._id;
    }
    get tileSet() {
        return this._cesiumEntity;
    }
    get heightMap() {
        return this._heightMap;
    }
    get geometry() {
        return this._geometry;
    }
    constructor(id, cesiumEntity, viewer, input) {
        this._id = id;
        this._cesiumEntity = cesiumEntity;
        this._viewer = viewer;
        this._viewer.scene.primitives.add(this._cesiumEntity);
        this._cesiumEntity.maximumScreenSpaceError = 16.0;
        this._viewer.zoomTo(this._cesiumEntity);
        // Apply the default style if it exists
        const extras = this._cesiumEntity.asset.extras;
        if (defined(extras) &&
            defined(extras.ion) &&
            defined(extras.ion.defaultStyle)) {
            this._cesiumEntity.style = new Cesium3DTileStyle(extras.ion.defaultStyle);
        }
        if (input.styleOptions) {
            this._styleOptions = input.styleOptions;
            this._setStyle(input.styleOptions);
        }
        else {
            this._styleOptions = {
                design: {
                    mesh_color: {
                        r: 255,
                        g: 255,
                        b: 255,
                    },
                },
                common: {
                    transparency: 1,
                },
            };
            this._setStyle(this._styleOptions);
        }
        this._geometry = createPointCloudGeom(input);
        this._heightMap = HeightMap.FromIndexedGeometry(this._geometry, DEFAULT_HEIGHT_MAP_BOX_SIZE);
    }
    updateTransparency(value = 1.0) {
        this._styleOptions.common.transparency = value;
        this._setStyle(this._styleOptions);
    }
    updateColor(color) {
        const { r, g, b } = color;
        this._styleOptions.design.mesh_color.r = r;
        this._styleOptions.design.mesh_color.g = g;
        this._styleOptions.design.mesh_color.b = b;
        this._setStyle(this._styleOptions);
    }
    _setStyle(style) {
        const { transparency } = style.common;
        const { r, g, b } = style.design.mesh_color;
        this._cesiumEntity.style = new Cesium3DTileStyle({
            color: `rgba(${r}, ${g}, ${b},${transparency})`,
        });
    }
    updateVisibility(status) {
        this._cesiumEntity.show = status;
    }
    zoomTo() {
        this._viewer.zoomTo(this._cesiumEntity);
    }
    rayCast(ray) {
        return this._heightMap.rayCast(ray);
    }
    getProjectPointHeight(refPoint) {
        const ray = new Ray(new Cartesian3(refPoint.x, refPoint.y, refPoint.z + 10000), new Cartesian3(0, 0, -1));
        const pointOnTileset = this.rayCast(ray);
        return pointOnTileset !== undefined ? pointOnTileset.z : undefined;
    }
    dispose() {
        this._viewer.scene.primitives.remove(this._cesiumEntity);
    }
    //ToDo-2965 Decide if we should keep this
    getGeodeticNormal() {
        return new Cartesian3(0, 0, 1);
    }
    tracePoints(points) {
        return EarthBrainUtils.tracePointsOnGeometry(this._geometry, this.heightMap, points);
    }
}
//# sourceMappingURL=design.js.map